import { error as logError } from '../utils/logger'
import { apiUrl } from '../config/config'
import { sendRequest } from '../utils/FetchServices'

interface PropsGetGamification {
    authToken: string
    version?: string
    retries?: number
    timeout?: number
}

export const request_get_gamification = async ({ authToken, version = '0', retries = 2, timeout = 10 }: PropsGetGamification) => {
    const URL = apiUrl + '/oneapp/gamification'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)

        if (!data.response?.single) return { levels: [], points: 0 }
        let levels = data.response.single.levels ? data.response.single.levels : []
        let points = data.response.single.points ?? 0
        let zip_assets = data.response.single.zip_assets ?? null
        let userLevel = data.response.single.level ?? 0
        let parallax = data.response.single.parallax ?? []
        let newVersion = data.response.single.version ?? '0'

        return { levels, points, zip_assets, userLevel, parallax, newVersion: newVersion }
    } catch (error) {
    logError('GamificationService', 'request_get_gamification failed', error)
        return { levels: [], points: 0 }
    }
}
interface PropsGetRanking {
    authToken: string
    version?: string | null
    retries?: number
    timeout?: number
}
export const request_gamification_ranking = async ({ authToken, version, retries = 2, timeout = 10 }: PropsGetRanking) => {
    const URL = apiUrl + '/oneapp/gamification_ranking'
    try {
        const headers = {
            Authorization: authToken,
            version: version,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)
        return data.response
    } catch (error) {
    logError('GamificationService', 'request_ranking failed', error)
        return null
    }
}
interface PropsHistory {
    authToken: string
    page: number
    limit: number
    retries?: number
    timeout?: number
}
export const request_gamification_history = async ({ authToken, page = 0, limit = 10, retries = 2, timeout = 10 }: PropsHistory) => {
    const URL = apiUrl + '/oneapp/points_history'
    try {
        const headers = {
            Authorization: authToken,
            page: page,
            limit: limit,
        }
        const data = await sendRequest(URL, 'GET', headers, null, retries, timeout)
        return data.response
    } catch (error) {
    logError('GamificationService', 'points_history failed', error)
        return null
    }
}
